import { footerLinks } from '@/mocks/home';

export default function Footer() {
  const sections = [
    footerLinks.comicCategories,
    footerLinks.quickLinks,
    footerLinks.resources,
    footerLinks.about,
  ];

  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                {section.title}
              </h4>
              <div className="w-8 h-px bg-secondary-300 mb-4"></div>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-accent-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="font-heading text-3xl md:text-4xl font-black text-foreground-950">歪歪</span>
              <span className="font-heading text-3xl md:text-4xl font-black text-accent-500">漫画</span>
            </div>
            <div className="w-12 h-px bg-secondary-300 mt-3 mb-2"></div>
            <p className="text-xs text-foreground-600">
              歪歪漫画网 - 韩漫无删减每日大赛独家吃瓜基地
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-accent-500 hover:bg-accent-100 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-accent-500 hover:bg-accent-100 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-accent-500 hover:bg-accent-100 transition-colors duration-200 cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>

          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 歪歪漫画网 版权所有
          </p>
        </div>
      </div>
    </footer>
  );
}